module.exports = __webpack_public_path__ + "img/1-2.d0e01f3e.jpg";